import React from 'react';

interface Props {
  fontSize?: number | string;
}

const FlagGerman: React.FC<Props> = ({ fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px` }}
      viewBox="0 0 640 480"
    >
      <path fill="#ffce00" d="M0 320h640v160H0z" />
      <path fill="#000" d="M0 0h640v160H0z" />
      <path fill="#d00" d="M0 160h640v160H0z" />
    </svg>
  );
};

export default FlagGerman;
